export const screenName = 'batch-ticket-detail';
